import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavContent, NgbNavOutlet } from '@ng-bootstrap/ng-bootstrap';
import { ProductOrientation } from 'src/app/models/layout/product-orientation';
import { PlanogramProblemType } from 'src/app/models/planogram-problem-type';
import { PlanogramProblemsService } from 'src/app/services/planogram-problems.service';
import { NgIf, NgFor } from '@angular/common';
import { ProductReference } from 'src/app/models/layout/product-reference';
import { PlanogramApiService } from 'src/app/services/planogram-api.service';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
    selector: 'app-problems-modal',
    templateUrl: './problems-modal.component.html',
    styleUrl: './problems-modal.component.scss',
    imports: [NgIf, NgbNav, NgFor, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavContent, NgbNavOutlet]
})
export class ProblemsModalComponent implements OnInit {
  problemTypes: PlanogramProblemType[] = [];
  PlanogramProblemType = PlanogramProblemType;
  ProductOrientation = ProductOrientation;

  constructor(
    public activeModal: NgbActiveModal, 
    public planogramProblemsService: PlanogramProblemsService,
    private planogramApiService: PlanogramApiService,
    private layoutService: LayoutService
  ) { }

  ngOnInit(): void {
    this.problemTypes = this.planogramProblemsService.getProblemTypesWithData();
  }

  flagProduct(product: ProductReference): void {
    this.planogramApiService.flagProductCaptureRequired(product.productId).subscribe(success => {
      if (success) {
        this.layoutService.flagProductCaptureRequired(product.productId);
      }
    });
  }

  getProblemMessage(problemType: PlanogramProblemType): string | null {
    switch (problemType) {
      case PlanogramProblemType.MissingDimensions:
        return "Some products have missing dimensions. Please ensure correct dimensions are recorded in DataMan and refresh data.";
      case PlanogramProblemType.MissingImages:
        return "Some products do not have images assigned.";
      case PlanogramProblemType.NoSalesOrVolume:
        return "These products have no recorded sales or volume data.";
      case PlanogramProblemType.FlowOrderZero:
        return "These products have a Flow Order of zero, which may affect merchandising order.";
      default:
        return null;
    }
  }

  close(): void {
    this.activeModal.close(null);
  }
}